export default "__VITE_ASSET__9e3197bb__"